<template>
  <wa-page-focused v-if="isLoading">
    <wa-page-loading slot="card" />
  </wa-page-focused>

  <not-found-view v-else-if="skuNotFound" />

  <success-view
    v-else-if="currentOrder"
    slot="content"
    :current-product="product"
    :product-sku="productSku"
    :is-new-account="isNewAccount"
    :theme="theme"
  />

  <wa-page-purchase
    v-else
    type="commission"
  >
    <wa-page-header-limited
      slot="page-header"
      key="header"
      :title="pageTitle"
      is-showing-cancel
    />

    <template slot="purchase-product">
      <commission-card
        v-if="product.sku === 'CI-SINGLE'"
        :theme="theme"
        avatar="faSquare"
        :cost="300"
        description="Add that single icon you've always wanted in all of Font Awesome's styles."
        :icon-count="1"
        type="icon"
      />

      <commission-card
        v-if="product.sku === 'CI-SIXPACK'"
        :theme="theme"
        avatar="faGrip"
        :cost="1500"
        description="Just say the magic word, and six icons of your choice will appear in all of our styles."
        :icon-count="6"
        type="icon"
      />

      <commission-card
        v-if="product.sku === 'CI-CASE24'"
        :theme="theme"
        avatar="faGrid5"
        :cost="4800"
        description="Your wish is our command — add twenty-four icons of your choice in all of our styles."
        :icon-count="24"
        type="icon"
      />

      <commission-card
        v-if="product.sku === 'CI-BRAND'"
        :theme="theme"
        avatar="faStar"
        :cost="3000"
        description="Make your brand's existing logo known and accessible to millions of users by adding it to Font Awesome Free."
        :icon-count="1"
        type="logo"
      />
    </template>

    <purchase-form
      slot="purchase-flow"
      :theme="theme"
      :total-cents="totalCents"
      :billing-description="billingDescription"
      :current-product="product"
    />

    <commission-faqs slot="purchase-support" />
  </wa-page-purchase>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  import CommissionCard from './components/CommissionCard'
  import CommissionFaqs from './components/CommissionFaqs'
  import NotFoundView from './NotFoundView'
  import PurchaseForm from './PurchaseForm'
  import SuccessView from './SuccessView'

  export default {
    name: 'CommissionView',

    components: {
      CommissionCard,
      CommissionFaqs,
      NotFoundView,
      PurchaseForm,
      SuccessView
    },

    props: {
      theme: {
        type: String,
        default: 'purple'
      }
    },

    data() {
      return {
        isLoading: true,
        productSku: '',
        product: null,
        skuNotFound: false
      }
    },

    computed: {
      ...mapGetters('orders', ['currentOrder']),

      pageTitle() {
        if (this.currentOrder) {
          return 'Thanks for your commission!'
        } else {
          if (this.product) {
            return this.product.name
          } else {
            return 'Commission Icon(s)'
          }
        }
      },

      totalCents() {
        return this.product.price.amount
      },

      billingDescription() {
        return this.product.name
      },

      mappedSku() {
        const skuCode = this.$route.params.sku
        const mapper = { icon: 'CI-SINGLE', sixer: 'CI-SIXPACK', case: 'CI-CASE24', logo: 'CI-BRAND' }
        return mapper[skuCode]
      },

      isNewAccount() {
        try {
          return this.$route.query.new === true
        } catch {
          return false
        }
      }
    },

    async created() {
      try {
        this.product = await this.fetchProduct(this.mappedSku)
      } catch (e) {
        // product SKU not found - bad situation
        return (this.skuNotFound = true)
      }

      this.isLoading = false
    },

    methods: {
      ...mapActions('products', ['fetchProduct'])
    }
  }
</script>
